import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=4cdffe9a&scoped=true&"
import script from "./CommentItem.vue?vue&type=script&lang=ts&"
export * from "./CommentItem.vue?vue&type=script&lang=ts&"
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=4cdffe9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdffe9a",
  null
  
)

export default component.exports